document.addEventListener("DOMContentLoaded", function () {
  // 1. Animation reveal
  const initRevealAnimations = () => {
    const revealElements = document.querySelectorAll('.pk-reveal');
    if (!revealElements.length) return;

    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('pk-reveal--visible');
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: 0.1
      }
    );

    revealElements.forEach(el => {
      observer.observe(el);
    });
  };

  initRevealAnimations();

  // 2. CGV checker
  const setupCgvChecker = () => {
    const cgvCheckerInput = document.querySelector("#pk-cgv-checker");
    const checkoutButton = document.querySelector(".checkout-button");

    if (!cgvCheckerInput || !checkoutButton) return;

    const syncState = () => {
      if (cgvCheckerInput.checked) {
        checkoutButton.removeAttribute("disabled");
      } else {
        checkoutButton.setAttribute("disabled", "");
      }
    };

    syncState();

    // Remove of any old listeners
    cgvCheckerInput.onchange = null;

    // And listen changes
    cgvCheckerInput.addEventListener("change", syncState);
  };

  // Cart template
  if (window.location.pathname.startsWith("/cart")) {
    setupCgvChecker();
  }

  // Cart drawer
  document.addEventListener("cart:refresh", () => {
    setupCgvChecker();
  });

  // When the cart drawer opens for the first time
  const miniCart = document.getElementById("mini-cart");

  if (miniCart) {
    miniCart.addEventListener("transitionend", () => {
      if (miniCart.hasAttribute("open")) {
        setupCgvChecker();
      }
    });
  }
});
